import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { UserIcon } from 'lucide-react';
const NAMES = ['María', 'Laura', 'Sofía', 'Ana', 'Carmen', 'Isabel', 'Rosa', 'Elena'];
const CITIES = ['Buenos Aires', 'Ciudad de México', 'Bogotá', 'Santiago', 'Lima', 'Guadalajara', 'Monterrey', 'Medellín', 'Quito', 'Caracas'];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showNotification = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setNotification({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay
    const initialTimeout = setTimeout(showNotification, 5000);
    // Loop interval (random between 8-12 seconds + 4s display time)
    const intervalId = setInterval(() => {
      const randomDelay = Math.floor(Math.random() * 4000); // 0-4s extra delay
      setTimeout(showNotification, randomDelay);
    }, 12000); // Base interval
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(intervalId);
    };
  }, []);
  return <AnimatePresence data-id="element-1">
      {isVisible && <motion.div initial={{
      x: 100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-4 right-4 z-50 max-w-xs w-full bg-white rounded-lg shadow-lg border border-orange-100 p-4 flex items-center gap-3" data-id="element-2">
          <div className="bg-orange-100 p-2 rounded-full flex-shrink-0" data-id="element-3">
            <UserIcon className="w-5 h-5 text-orange-500" data-id="element-4" />
          </div>
          <div data-id="element-5">
            <p className="text-sm font-medium text-gray-900" data-id="element-6">
              {notification.name} de {notification.city}
            </p>
            <p className="text-xs text-gray-500" data-id="element-7">acaba de comprar este libro</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}